module.exports = __webpack_public_path__ + "img/fb_logo_big.c5c588a3.png";